import * as ShowType from 'show-page/constants/show-type';
import { CLIP } from 'common/constants/video-type';
import { CLIPS_PER_PAGE, VIDEOS_API_ENDPOINT, VIDEOS_API_FIELDS, VIDEOS_API_SORT } from 'show-page/constants/config';
import { action, computed, observable, reaction, when } from 'mobx';


class Season {
    @observable isLoading = false
    @observable number;
    @observable totalClips;

    constructor(store, number) {
        this.store = store;
        this.number = number;
        this.dispose = when(() => this.store.seasons.indexOf(this) === -1, () => this.destroy());
        this.selectedListener = reaction(
            () => this.store.selectedSeason,
            (selectedSeason) => (selectedSeason === this) ? this.loadClips() : null,
            true
        );
    }

    destroy() {
        this.dispose();
        this.dispose = null;
        this.selectedListener();
        this.selectedListener = null;
        this.store = null;
    }

    /*=======================================
    =            Computed Valeus            =
    =======================================*/

    @computed get canLoadMore() {
        return isNaN(this.totalClips) || this.clips.length < this.totalClips;
    }

    @computed get clips() {
        return this.store.clips.filter(clip => (parseInt(clip.seasonNumber, 10) === this.number));
    }

    @computed get episodes() {
        return this.store.episodes.filter(epi => (parseInt(epi.seasonNumber, 10) === this.number));
    }

    @computed get loadClipsUrl() {
        const q = [
            '_exists_:season_number',
            `collection_id:${this.store.collection.id}`,
            `season_number:${this.number}`,
            `type:"${CLIP}"`,
            'NOT+tags:404'
        ];
        const params = [
            `fields=${VIDEOS_API_FIELDS}`,
            `q=${q.join('+AND+')}`,
            `size=${CLIPS_PER_PAGE}`,
            `sort=${VIDEOS_API_SORT}`,
            `from=${Math.floor(this.clips.length / CLIPS_PER_PAGE) * CLIPS_PER_PAGE}`
        ];
        return `${VIDEOS_API_ENDPOINT}?${params.join('&')}`;
    }

    @computed get name() {
        return this.store.seasonNames[this.number];
    }

    @computed get showLatestClips() {
        return (this.store.clipsEnabled && (this === this.store.latestSeason) && this.clips.length);
    }

    @computed get videos() {
        switch (this.store.collection.type) {
            case ShowType.TV_SERIES:
                return this.episodes;
            default:
                return this.store.videos.filter(video => (parseInt(video.seasonNumber, 10) === this.number));
        }
    }


    /*===============================
    =            Actions            =
    ===============================*/

    @action setLoading = (isLoading) => {
        this.isLoading = !!isLoading;
    };

    @action setTotalClips = (total) => {
        this.totalClips = parseInt(total, 10) || 0;
    };


    /*====================================
    =            Base Methods            =
    ====================================*/

    loadClips() {
        if (!this.canLoadMore) {
            return Promise.resolve();
        }
        this.setLoading(true);
        return fetch(this.loadClipsUrl)
            .then(response => response.json())
            .then(json => {
                this.setTotalClips(json.count);
                this.store.addVideos(json.data);
                this.setLoading(false);
            })
            .catch(() => this.setLoading(false));
    }

}


export default Season;



// WEBPACK FOOTER //
// ./src/show-page/models/season.js